'use client';

import { FormText as CommonFormText } from '@monorepo/common';
import type { FieldValues, UseControllerProps } from 'react-hook-form';

interface RaffleFormTextProps<T extends FieldValues> extends UseControllerProps<T> {
  type?: 'text' | 'email' | 'password' | 'number' | 'tel';
  label?: string;
  placeholder?: string;
  autocomplete?: string;
  required?: boolean;
  readOnly?: boolean;
  prefix?: React.ReactNode;
  outlined?: boolean;
  onChange?: () => void;
  isSmall?: boolean;
  hint?: string;
  min?: number;
  max?: number;
  color?: 'primary' | 'error' | 'gray' | 'black' | 'white';
  className?: string;
  /** カスタムスタイルを無効にする場合 */
  noCustomStyle?: boolean;
}

export default function FormText<T extends FieldValues>({
  outlined,
  noCustomStyle = false,
  ...props
}: RaffleFormTextProps<T>) {
  return <CommonFormText outlined={outlined} {...props} />;
}

export type { RaffleFormTextProps as FormTextProps };
